<template>
  <div id="diagram">
    <div class="btn-container">
      <input type="radio" id="graph1" value="graph1" v-model="checked" @change="getDataMarcus(query1,color1)">
      <label for="graph1">graph1</label>
      <input type="radio" id="graph2" value="graph2" v-model="checked" @change="getDataMarcus(query2,color2)">
      <label for="graph2">graph2</label>
      <input type="radio" id="graph3" value="graph3" v-model="checked" @change="getDataMarcus(query3,color3)">
      <label for="graph3">graph3</label>
      <input type="radio" id="all" value="All" v-model="checked" @change="getDataMarcus(queryAll,'rgb(0,0,0)')">
      <label for="graph3">All</label>
      <button @click="draw(dataE)">Diagram</button> 
    </div>
    <div id="sigma-container" ref="sigmaContainer">
    </div>
  </div>
</template>

<script>
import Sigma from "sigma";
import FA2Layout from "graphology-layout-forceatlas2/worker";
import Graph from "graphology";
// import { v4 as uuid } from "uuid";
import { commonMixin } from '../common.js'
import {MultiDirectedGraph} from 'graphology';

export default {
  mixins: [commonMixin],
  props: {
    db: {
      required: true,
      type: Object,
    },
    tab: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      targetJ: null,
      sourceJ: null,
      checked:[],
      nodes: [],
      nodes2:[],
      nodesOption: null,
      noedsDraw:[],
      edges: [],
      edges2: [],
      linktbl: [],
      nodesSigma: [],
      edgesSigma: [],
      edgName: [],
      dataS: {
        nodes: [],
        edges: []
      },
      dataBase: {
        nodes: [],
        edges: []
      },
      dataE: {
        nodes: [],
        edges: []
      },
      color:null,
      color1: 'rgb(138, 43, 226)',
      color2: 'rgb(245, 66, 66)',
      color3: 'rgb(66, 245, 90)',
      colorArr: ['rgb(138, 43, 226)','rgb(245, 66, 66)','rgb(66, 245, 90)'],
      query1: 'SELECT Prec.TransID as [Transaction #], A1.HolderName as [Sender Name], Prec.PaymentAmount as [Payment Amount], A2.HolderName as [Recepient Name] MATCH (Accounts A1)<-[PmntSender01]-(PaymentRecords Prec)-[PmntReceiver01]->(Accounts A2)', 
      query2: 'SELECT Prec.TransID as [Transaction #], A1.HolderName as [Sender Name], Prec.PaymentAmount as [Payment Amount], A2.HolderName as [Recepient Name] MATCH (Accounts A1)<-[PmntSender02]-(PaymentRecords Prec)-[PmntReceiver02]->(Accounts A2)', 
      query3: 'SELECT Prec.TransID as [Transaction #], A1.HolderName as [Sender Name], Prec.PaymentAmount as [Payment Amount], A2.HolderName as [Recepient Name] MATCH (Accounts A1)<-[PmntSender03]-(PaymentRecords Prec)-[PmntReceiver03]->(Accounts A2)',
      queryAll: 'SELECT Prec.TransID as [Transaction #], A1.HolderName as [Sender Name], Prec.PaymentAmount as [Payment Amount], A2.HolderName as [Recepient Name] MATCH (Accounts A1)<-[PmntSender01]-(PaymentRecords Prec)-[PmntReceiver01]->(Accounts A2) SELECT Prec.TransID as [Transaction #], A1.HolderName as [Sender Name], Prec.PaymentAmount as [Payment Amount], A2.HolderName as [Recepient Name] MATCH (Accounts A1)<-[PmntSender02]-(PaymentRecords Prec)-[PmntReceiver02]->(Accounts A2) SELECT Prec.TransID as [Transaction #], A1.HolderName as [Sender Name], Prec.PaymentAmount as [Payment Amount], A2.HolderName as [Recepient Name] MATCH (Accounts A1)<-[PmntSender03]-(PaymentRecords Prec)-[PmntReceiver03]->(Accounts A2)',

      addEdges:[],

      selectedTbl: null,
      selectedNode: null,
      selectedEdge:null,

      graph: null,
      graph2: null,
      container:null,
      searchInput: null,
      searchSuggestions: null,
      renderer:null,
      renderer2:null,

      hoveredNode: null,
      searchQuery: null,

      // State derived from query:
      selectedNode: null,
      suggestions: null,

      // State derived from hovered node:
      hoveredNeighbors: null,

    }
  },
  methods: {
    getOptinsNode() {
      let tblindex = this.db.data.findIndex(item => item.tablename == this.selectedTbl.tablename)
      return this.nodes2.filter((item,index) => index == tblindex)[0]
    },
    dbTableNodes() {
      console.log('daTablN');
      this.nodes2 = []
      let query = ''
      this.db.data.forEach((el,ind) => {
        if(el.type===2) {
          this.nodes2.push(el.tablename)
          query += `SELECT * FROM ${el.tablename}; `
        }
      })
      this.ExecScript(
        this.db,
        query, (response) => {
          console.log('el', response);
          if (response.err > 0) {
            this.ShowAlert(response.msg)
          } else {
            response.data.forEach((element,index) => {
              this.nodes2[index] = element.data
            })
          }
        },
      true, 0);
    },
    getNodeEdges() {
      this.edges2 = []
      let queryArr = []
      this.linktbl = []
      this.dataS.nodes=[]
      this.dataS.edges=[]
      let k = 2
      let i = 1
      let a = 0
      let b = 0
      let m = 0
      this.db.data.forEach((el,ind) => {
        if(el.type===3) {
          this.edgName.push(el.tablename)
          let arrTab1 = this.db.data.find(item => item.tablename === el.fields[0].linktable);
          let arrTab2 = this.db.data.find(item => item.tablename === el.fields[1].linktable);
          let col1 = arrTab1.fields.find(item => item.subtype === 1);
          let col2 = arrTab2.fields.find(item => item.subtype === 1);
          console.log(arrTab1.tablename);
          let indCol1 =  arrTab1.fields.findIndex(item => item.subtype === 1);
          let indCol2 =  arrTab2.fields.findIndex(item => item.subtype === 1);
          this.linktbl.push({tblname1:arrTab1.tablename,tblname2:arrTab2.tablename,col1:indCol1,col2:indCol2,edgeInd:m})
          queryArr.push(`SELECT TOP 1000 t1.${col1.name}, t2.${col2.name} FROM ${el.tablename} t JOIN ${el.fields[0].linktable} t${i} on t.fromid = t${i}.${col1.name} JOIN ${el.fields[1].linktable} t${k} on t.toid = t${k}.${col2.name} where t1.${col1.name} = '${this.selectedNode[0]}'`)
          if ((ind+1)%2 == 0) {
            i-- 
            k++           
          } else {
            i++
            k--
          }
          m++
        }
      }) 
      let query = queryArr.join(' ')
      console.log('edge', query);
      this.ExecScript(
        this.db,
        query, (response) => {
          if (response.err > 0) {
            this.ShowAlert(response.msg)
          } else {
            response.data.forEach((element,index) => {
              let color = this.getRandomColor()
              element.data.forEach((item,indexE) => {
                if(indexE == 0 && index == 0) {
                  this.dataS.nodes.push({
                    el: this.nodes2[index].filter(itemN => itemN[this.linktbl[0].col1] == item[0])[0],
                    key: a,
                    attributes: {
                      // randomInteger(min,max)
                      x: 0.5,
                      y: 0.5,
                      size: 15,
                      label: `${item[0]}`,
                      tbl: `${index}`,
                      color: '#306996'
                    }
                  })
                  a++
                  this.dataS.nodes.push({
                    el: this.nodes2[index].filter(itemN => itemN[this.linktbl[0].col1] == item[1])[0],
                    key: a,
                    attributes: {
                      // randomInteger(min,max)
                      // x:0.5*10000,
                      x: Math.random(),
                      // y:0.5*10000,
                      y: Math.random(),
                      size: 10,
                      label: `${item[1]}`,
                      tbl: `${index}`,
                      color: color
                    }
                  })
                  a++
                } else {
                  this.dataS.nodes.push({
                    el: this.nodes2[index].filter(itemN => itemN[this.linktbl[0].col1] == item[1])[0],
                    key: a,
                    attributes: {
                      // randomInteger(min,max)
                      // x: 0.5*10000,
                      x: Math.random(),
                      // y: 0.5*10000,
                      y: Math.random(),
                      size: 10,
                      label: `${item[1]}`,
                      tbl: `${index}`,
                      color: color
                    }
                  })
                  a++
                }
                this.dataS.edges.push({
                  key: b,
                  source: this.dataS.nodes.filter(itemN => itemN.el[this.linktbl[0].col1] == item[0])[0].key,
                  target: this.dataS.nodes.filter(itemN => itemN.el[this.linktbl[0].col1] == item[1])[0].key,
                  attributes: {
                    type: `arrow`,
                    label: `${this.edgName[index]}`,
                    size: 5
                  }
                })
                b++
              })
            })
          }
        },
      true, 0);
    },
    getData(){
      this.nodes = []
      this.edges = []
      this.dataBase.nodes=[]
      this.dataBase.edges=[]
      let query='';
      let i = 0
      let k = 0
      this.db.data.forEach((el,ind) => {
        if(el.type===2) {
          this.nodes.push(el.tablename)
          // let x = 0.25 * 10000 + 0.5 * 10000 * ind
          // let y = 0.5 * 10000
          // this.dataBase.nodes.push({
          //   key: `${this.db.dbname}_`+`${i}`,
          //   attributes: {
          //     x: x,
          //     y: y,
          //     size: 20,
          //     label: el.tablename,
          //     color: "#306996"
          //   }
          // })
          // i++
          query += `SELECT * FROM ${el.tablename};`
        }
        if(el.type===3) {
          let arrTab1 = this.db.data.find(item => item.tablename === el.fields[0].linktable);
          let arrTab2 = this.db.data.find(item => item.tablename === el.fields[1].linktable);
          let col1 = arrTab1.fields.find(item => item.subtype === 1);
          let col2 = arrTab2.fields.find(item => item.subtype === 1);
          let indCol1 =  arrTab1.fields.findIndex(item => item.subtype === 1);
          let indCol2 =  arrTab2.fields.findIndex(item => item.subtype === 1);
          this.linktbl.push({
            tblname1: arrTab1.tablename,
            tblname2: arrTab2.tablename,
            col1: indCol1,
            col2: indCol2
          })
          query += `SELECT t1.${col1.name}, t2.${col2.name} FROM ` + el.tablename + " t JOIN " + el.fields[0].linktable + ` t1 on t.fromid = t1.${col1.name} JOIN ` + el.fields[1].linktable + ` t2 on t.toid = t2.${col2.name};`;
        }
      });
      this.ExecScript(
        this.db,
        query, (response) => {
          response.data.forEach((element,index) => {
            let min = (0 + 0.5*index)
            let max = (0.5 + 0.5*index) 
            let x = 0 + 10000*index 
            if (element.err > 0) {
              this.ShowAlert(element.msg)
            } else {
              if(index <= this.nodes.length-1) {
                let color = this.getRandomColor(); 
                this.nodes[index] = element.data
                element.data.forEach((item,count) => {
                  let y = 0+2*count
                            // 0.3858281368932277

                   this.dataBase.nodes.push({
                    el: this.nodes2[index].filter(itemN => itemN[this.linktbl[0].col1] == item[0])[0], 
                    key: `${item[0]}`,
                    attributes: {
                      // randomInteger(min,max)
                      // x: this.randomInteger(min,max),
                      x: x,
                      // y: Math.random(),
                      y: y,
                      size: 1,
                      // label: `${item[1]} ` + `${item[2]}`,
                      label: `${item[0]} ${item[1]} ${item[2]}`,
                      tbl: `${index}`,
                      color: color
                    }
                  })
                  //  this.dataBase.edges.push({
                  //   key: k,
                  //   source: `${item[0]}`,
                  //   target: `${this.dataBase.nodes[index].key}`,
                  //   attributes: {
                  //     size: 2
                  //   }
                  // })
                  i++
                  k++
                })
              } else {
                this.edges = this.edges.concat(element.data)
                element.data.forEach(item => {
                  this.dataBase.edges.push({
                    key: k,
                    source: `${item[0]}`,
                    target: `${item[1]}`,
                    attributes: {
                      size: 1
                    }
                  })
                  k++
                })
              }
            }
          })    
        }, 
      true, 0);
    },
    draw(data) {
      // State derived from hovered node:
      if (this.graph) this.graph.clear()
      
      this.hoveredNeighbors = null,
      // this.graph = new Graph({multi: true});
      this.graph = new MultiDirectedGraph({multi: true, allowSelfLoops: false});
      let dataS = {
        nodes: [],
        edges: []
      }
      
      dataS.nodes = this.nodesSigma
      dataS.edges = this.edgesSigma

      // Create the sigma
      this.graph.import(data);
      // this.graph.import(this.dataS);

      // Create the spring layout and start it
      const layout = new FA2Layout(this.graph, { isNodeFixed: (_, attr) => attr.highlighted });
      layout.start();
      setTimeout(()=>layout.stop(),1000)
      // layout.stop();

      const container = this.$refs.sigmaContainer
      const searchSuggestions = this.$refs.suggestions

      // State for drag'n'drop
      let draggedNode = null;
      let isDragging = false;

      // Instantiate sigma:
  
      this.renderer = new Sigma(this.graph, container, {
        renderEdgeLabels: true,
      });

      this.renderer.on("enterNode", ({ node }) => {
        this.setHoveredNode(node);
      });
      this.renderer.on("leaveNode", () => {
        this.setHoveredNode(undefined);
      });
      this.renderer.on("downNode", (e) => {
        isDragging = true;
        draggedNode = e.node;
        this.graph.setNodeAttribute(draggedNode, "highlighted", true);
        this.renderer.getCamera().disable();
      });
     
      this.renderer.setSetting("nodeReducer", (node, data) => {
        const res = { ...data };

        if (this.hoveredNeighbors && !this.hoveredNeighbors.has(node) && this.hoveredNode !== node) {
          res.label = "";
          res.color = "#f6f6f6";
        }

        if (this.selectedNode === node) {
          res.highlighted = true;
        } else if (this.suggestions && !this.suggestions.has(node)) {
          res.label = "";
          res.color = "#f6f6f6";
        }

        return res;
      });
     
      this.renderer.setSetting("edgeReducer", (edge, data) => {
        const res  = { ...data };
        if (this.hoveredNode && !this.graph.hasExtremity(edge, this.hoveredNode)) {
          res.hidden = true;
        }

        if (this.suggestions && (!this.suggestions.has(this.graph.source(edge)) || !this.suggestions.has(this.graph.target(edge)))) {
          res.hidden = true;
        }
        
        return res;
      });

      this.renderer.getMouseCaptor().on("mousemovebody", (e) => {
        if (!isDragging || !draggedNode) return;
            // Get new position of node
        const pos = this.renderer.viewportToGraph(e);

        this.graph.setNodeAttribute(draggedNode, "x", pos.x);
        this.graph.setNodeAttribute(draggedNode, "y", pos.y);
      })
    
      this.renderer.getMouseCaptor().on("mouseup", () => {
        if (draggedNode) {
          this.graph.removeNodeAttribute(draggedNode, "highlighted");
        }
        isDragging = false;
        draggedNode = null;
        this.renderer.getCamera().enable();
      });
    
      // Disable the autoscale at the first down interaction
      this.renderer.getMouseCaptor().on("mousedown", () => {
        if (!this.renderer.getCustomBBox()) this.renderer.setCustomBBox(this.renderer.getBBox());
      });
    },
    draw2(data) {
      // State derived from hovered node:
      if (this.graph) this.graph.clear()
      
      this.hoveredNeighbors = null,
      this.graph = new Graph();
      // this.graph = new MultiDirectedGraph();
      let dataS = {
        nodes: [],
        edges: []
      }
      
      dataS.nodes = this.nodesSigma
      dataS.edges = this.edgesSigma

      // Create the sigma
      this.graph.import(data);
      // this.graph.import(this.dataS);

      // Create the spring layout and start it
      // const layout = new ForceSupervisor(this.graph, { isNodeFixed: (_, attr) => attr.highlighted });
      // layout.start();

      const container = this.$refs.sigmaContainer
      const searchSuggestions = this.$refs.suggestions

      // State for drag'n'drop
      let draggedNode = null;
      let isDragging = false;

      // Instantiate sigma:
  
      this.renderer = new Sigma(this.graph, container, {
        renderEdgeLabels: true,
      });
      searchSuggestions.innerHTML = this.graph
        .nodes()
        .map((node) => `<option value="${this.graph.getNodeAttribute(node, "label")}"></option>`)
        .join("\n");
      this.renderer.on("enterNode", ({ node }) => {
        this.setHoveredNode(node);
      });
      this.renderer.on("leaveNode", () => {
        this.setHoveredNode(undefined);
      });
      this.renderer.on("downNode", (e) => {
        isDragging = true;
        draggedNode = e.node;
        this.graph.setNodeAttribute(draggedNode, "highlighted", true);
        this.renderer.getCamera().disable();
      });
      
      this.renderer.setSetting("nodeReducer", (node, data) => {
        const res = { ...data };

        if (this.hoveredNeighbors && !this.hoveredNeighbors.has(node) && this.hoveredNode !== node) {
          res.label = "";
          res.color = "#f6f6f6";
        }

        if (this.selectedNode === node) {
          res.highlighted = true;
        } else if (this.suggestions && !this.suggestions.has(node)) {
          res.label = "";
          res.color = "#f6f6f6";
        }

        return res;
      });

      this.renderer.setSetting("edgeReducer", (edge, data) => {
        const res  = { ...data };

        if (this.hoveredNode && !this.graph.hasExtremity(edge, this.hoveredNode)) {
          res.hidden = true;
        }

        if (this.suggestions && (!this.suggestions.has(this.graph.source(edge)) || !this.suggestions.has(this.graph.target(edge)))) {
          res.hidden = true;
        }

        return res;
      });

      // On mouse move, if the drag mode is enabled, we change the position of the draggedNode
      this.renderer.getMouseCaptor().on("mousemovebody", (e) => {
        if (!isDragging || !draggedNode) return;
            // Get new position of node
        const pos = this.renderer.viewportToGraph(e);

        this.graph.setNodeAttribute(draggedNode, "x", pos.x);
        this.graph.setNodeAttribute(draggedNode, "y", pos.y);
      })
    
      this.renderer.getMouseCaptor().on("mouseup", () => {
        if (draggedNode) {
          this.graph.removeNodeAttribute(draggedNode, "highlighted");
        }
        isDragging = false;
        draggedNode = null;
        this.renderer.getCamera().enable();
      });
    
      // Disable the autoscale at the first down interaction
      this.renderer.getMouseCaptor().on("mousedown", () => {
        if (!this.renderer.getCustomBBox()) this.renderer.setCustomBBox(this.renderer.getBBox());
      });

      this.renderer.on('clickNode', (e)=> {
        console.log('M Click', e, data.nodes[e.node].el[0]);
        const nodeLable = data.nodes[e.node].el[0]
        // const result = this.dataBase.nodes.filter(k => k.)
        this.graph.addNode(this.dataBase.nodes[3]);
      })

      //
      // Create node (and edge) by click
      // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
      //

      // When clicking on the stage, we add a new node and connect it to the closest node
      // this.renderer.on("clickStage", event  => {})
    },
    setSearchQuery() {
      // this.searchQuery = query;

      // if (this.searchInput == query) this.searchInput = query;

      if (this.searchInput) {
        const lcQuery = this.searchInput.toLowerCase();
        const suggestions = this.graph
          .nodes()
          .map((n) => ({ id: n, label: this.graph.getNodeAttribute(n, "label")}))
          .filter(({ label }) => label.toLowerCase().includes(lcQuery));

        // If we have a single perfect match, them we remove the suggestions, and
        // we consider the user has selected a node through the datalist
        // autocomplete:
        if (suggestions.length === 1 && suggestions[0].label === this.searchInput) {
          this.selectedNode = suggestions[0].id;
          this.suggestions = undefined;

          // Move the camera to center it on the selected node:
          const nodePosition = this.renderer.getNodeDisplayData(this.selectedNode);
          this.renderer.getCamera().animate(nodePosition, {
            duration: 500,
          });
        }
        // Else, we display the suggestions list:
        else {
          this.selectedNode = undefined;
          this.suggestions = new Set(suggestions.map(({ id }) => id));
        }
      }
      // If the query is empty, then we reset the selectedNode / suggestions this:
      else {
        this.selectedNode = undefined;
        this.suggestions = undefined;
      }

      // Refresh rendering:
      this.renderer.refresh();
    },
    setHoveredNode(node) {
      if (node) {
        this.hoveredNode = node;
        this.hoveredNeighbors = new Set(this.graph.neighbors(node));
      } else {
        this.hoveredNode = undefined;
        this.hoveredNeighbors = undefined;
      }

      // Refresh rendering:
      this.renderer.refresh();
    },
    getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    randomInteger(min, max) {
      let rand = min + Math.random() * (max + 1 - min);
      return Math.floor(rand);
    },
    filterNE(edges) {
      this.addEdges = []
      // console.log(this.dataBase.edges);
      edges.forEach(i=> {
        // console.log(i);
        if(i.target == this.selectedNode[0]) {
          this.addEdges.push(i)
          this.dstaE.edges.push(i)
        }
      })

      // this.filterNE(n)
      // const result = this.dataBase.edges.filter((elemntE,index) => {
      //   if (index === 0) {
      //     console.log(elemntE);
      //     console.log(this.selectedNode);            
      //     console.log(elemntE.source == this.selectedNode[0]);            
      //   }
      //   elemntE.source == 'person1'
      // })
      console.log(this.addEdges);
    },
    getDataMarcus(query,color) {
      this.dataE.nodes = []
      this.dataE.edges = []
      let k = 0.0
      let b = 1
      this.ExecScript(
        this.db,
        query, (response) => {
          console.log(response);
          if (response.data[0].err > 0) {
            this.ShowAlert(response.data[0].msg)
          } else {
            response.data.forEach((element,index) => {
              if (Array.isArray(color)) {
                this.color = color[index];
              } else {
                this.color = color
              }
              element.data.forEach((el,ind) => {
                // debugger
                if(this.dataE.nodes.length > 0) {
                  // console.log(this.dataE.nodes.filter(i => i.name == el[1]).length);
                  if(!(this.dataE.nodes.filter(i => i.name == el[1]).length>0)) {
                    if(ind == (element.data.length-1)) {
                      this.dataE.nodes.push({
                        key: uuid(),
                        name: el[1],
                        attributes: {
                          x: Math.random(),
                          y: Math.random(),
                          size: 15,
                          // label: `${item[1]} ` + `${item[2]}`,
                          label: `${el[1]}`,
                          tbl: `${index}`,
                          color: '#306996'
                        }
                      })
                      k++
                      this.dataE.nodes.push({
                        key: uuid(),
                        name: el[3],
                        attributes: {
                          x: Math.random(),
                          y: Math.random(),
                          size: 15,
                          // label: `${item[1]} ` + `${item[2]}`,
                          label: `${el[3]}`,
                          tbl: `${index}`,
                          color: '#306996'
                        }
                      })
                      k++
                    } else {
                      this.dataE.nodes.push({
                        key: uuid(),
                        name: el[1],
                        attributes: {
                          x: Math.random(),
                          y: Math.random(),
                          size: 15,
                          // label: `${item[1]} ` + `${item[2]}`,
                          label: `${el[1]}`,
                          tbl: `${index}`,
                          color: '#306996'
                        }
                      })
                      k++
                    } 
                  } else {
                    if(ind == (element.data.length-1)) {
                      if(!(this.dataE.nodes.filter(i => i.name == el[3]).length>0)) {
                        this.dataE.nodes.push({
                          key: uuid(),
                          name: el[3],
                          attributes: {
                            x: Math.random(),
                            y: Math.random(),
                            size: 15,
                            // label: `${item[1]} ` + `${item[2]}`,
                            label: `${el[3]}`,
                            tbl: `${index}`,
                            color: '#306996'
                          }
                        })
                        k++
                      }
                    }
                  }
                } else {
                  // debugger 
                  // if(!(this.dataE.nodes.filter(i => i.name == el[1]).length>0)) {
                    if(ind == (element.data.length-1)) {
                      this.dataE.nodes.push({
                        key: uuid(),
                        name: el[1],
                        attributes: {
                          x: Math.random(),
                          y: Math.random(),
                          size: 15,
                          // label: `${item[1]} ` + `${item[2]}`,
                          label: `${el[3]}`,
                          tbl: `${index}`,
                          color: '#306996'
                        }
                      })
                      k++  
                    }
                    this.dataE.nodes.push({
                      key: uuid(),
                      name: el[1],
                      attributes: {
                        x: Math.random(),
                        y: Math.random(),
                        size: 15,
                        // label: `${item[1]} ` + `${item[2]}`,
                        label: `${el[1]}`,
                        tbl: `${index}`,
                        color: '#306996'
                      }
                    })
                    k++
                  // }        
                }
              })
              element.data.forEach((el,ind) => {
                const source = this.dataE.nodes.filter(itemN => itemN.name == el[1])[0].key
                const target = this.dataE.nodes.filter(itemN => itemN.name == el[3])[0].key
                if (response.data.length>1) {
                  if(el[3]==='Joost') {
                    console.log(index,element.data.length);
                    this.targetJ = target
                  }
                  let label = `g${index+1}:${el[2]}`
                  let customLabels = [{ str: `${el[2]}`, color: this.colorArr[index]}]
                  let arr = this.dataE.edges.filter(i => i.source == source && i.target == target)
                  if(arr.length>0) {
                    let labelArr = ''
                    switch (arr.length) {
                      case 1:
                        arr.forEach((t,ind)=> {            
                          labelArr = `${t.attributes.label}`
                          customLabels.push({str: `${t.attributes.label}`, color: `${this.colorArr[ind]}`})
                        })
                        break;
                      case 2:
                        arr.forEach((t,ind)=> {            
                          labelArr = `${t.attributes.label}`
                          customLabels.push({str: `${t.attributes.label.split(' ')[0]}`, color: `${this.colorArr[ind]}`})
                        })
                        break;
                    }
                    label +=` ${labelArr}`
                  }
                  switch (index) {
                    case 1:    
                      this.dataE.edges.filter(i => i.target != target).map(i => i.attributes.color = 'rgb(255, 255, 255)')
                      break;
                    case 2:
                      let arrEdge4
                      if (ind == 22) {
                        let arrEdge3 = this.dataE.edges.filter(i => i.target == target)
                        arrEdge4 = this.dataE.edges.filter(i => i.count == 2)
                        console.log(ind,arrEdge4,this.targetJ);
                        arrEdge3.map(i => i.attributes.color = this.color3)
                        let edgeJoost = arrEdge4.filter(k => k.target == this.targetJ || k.source == this.sourceJ)
                        console.log('j',edgeJoost);
                        edgeJoost.map(i => i.attributes.color = this.color3)
                        this.color = this.color3
                      }
                     
                      break;
                  }
                  if(index == 0) {
                    this.color = 'rgb(255, 255, 255)'
                  }
                  this.dataE.edges.push({
                    key: uuid(),
                    source: this.dataE.nodes.filter(itemN => itemN.name == el[1])[0].key,
                    target: this.dataE.nodes.filter(itemN => itemN.name == el[3])[0].key,
                    count: index,
                    attributes: {
                      customLabels: customLabels,
                      type: `arrow`,
                      label: `${label}`,
                      size: 5,
                      // color: 'rgb(235, 93, 16)',
                      color: this.color,
                    }
                  })         
                } else {
                  this.dataE.edges.push({
                    key: uuid(),
                    source: this.dataE.nodes.filter(itemN => itemN.name == el[1])[0].key,
                    target: this.dataE.nodes.filter(itemN => itemN.name == el[3])[0].key,
                    count: index,
                    attributes: {
                      type: `arrow`,
                      label: `${el[2]}`,
                      size: 5,
                      color: this.color,
                    }
                  })
                }
              })
              b++
            })          
          }  
        },
        true,0
      );
    },
    getDataMarcusAll(query,check) {
      this.dataE.nodes = []
      this.dataE.edges = []
      let k = 0.0
      let b = 1
      this.ExecScript(
        this.db,
        query, (response) => {
          console.log(response);
          if (response.data[0].err > 0) {
            this.ShowAlert(response.data[0].msg)
          } else {
            response.data.forEach((element,index) => {
              let min = (0 + 1/3*index)
              let max = (1/3 + 1/3*index) 
              element.data.forEach((el,ind) => {
                if(this.dataE.nodes.length > 0) {
                  console.log(this.dataE.nodes);
                  let check = this.dataE.nodes.filter(i => i.name == el[1] && i.query == index)
                  // debugger
                  // console.log('begin',element.data);
                  if(ind == 0) {
                    // debugger
                    this.dataE.nodes.push({
                      key: uuid(),
                      name: el[1],
                      query: index,
                      el: el,
                      attributes: {
                        x: this.randomInteger(min,max)*10,
                        y: Math.random(),
                        size: 15,
                        // label: `${item[1]} ` + `${item[2]}`,
                        label: `${el[1]}`,
                        color: '#306996'
                      }
                    })
                    k++
                    console.log('begin',this.dataE.nodes)  
                  } else {
                    if(ind == element.data.length - 1) {
                      console.log('last',index);
                      this.dataE.nodes.push({
                        key: uuid(),
                        name: el[3],
                        query: index,
                        el: el,
                        attributes: {
                          x: this.randomInteger(min,max)*10,
                          y: Math.random(),
                          size: 15,
                          // label: `${item[1]} ` + `${item[2]}`,
                          label: `${el[3]}`,
                          color: '#306996'
                        }
                      })
                      console.log('last',this.dataE.nodes)
                      k++  
                    }
                    if(!check.length > 0) {
                      // console.log(this.dataE.nodes);
                      this.dataE.nodes.push({
                        key: uuid(),
                        name: el[1],
                        query: index,
                        el: el,
                        attributes: {
                          x: this.randomInteger(min,max)*10,
                          y: Math.random(),
                          size: 15,
                          // label: `${item[1]} ` + `${item[2]}`,
                          label: `${el[1]}`,
                          color: '#306996'
                        }
                      })
                      k++  
                    }
                  }
                } else {
                  if(ind == 0) {
                    this.dataE.nodes.push({
                      key: uuid(),
                      name: el[1],
                      query: index,
                      el: el,
                      attributes: {
                        x: this.randomInteger(min,max)*10,
                        y: Math.random(),
                        size: 15,
                        // label: `${item[1]} ` + `${item[2]}`,
                        label: `${el[1]}`,
                        color: '#306996'
                      }
                    })
                    k++  
                  }
                  this.dataE.nodes.push({
                    key: uuid(),
                    name: el[3],
                    query: index,
                    el: el,
                    attributes: {
                      x: this.randomInteger(min,max)*10,
                      y: Math.random(),
                      size: 15,
                      // label: `${item[1]} ` + `${item[2]}`,
                      label: `${el[3]}`,
                      color: '#306996'
                    }
                  })
                  k++  
                }        
              })
              element.data.forEach((el,ind) => {
                // console.log('edg',el);
                // console.log('edg2',this.dataS);
                this.dataE.edges.push({
                  key: uuid(),
                  source: this.dataE.nodes.filter(itemN => itemN.name == el[1] && itemN.query == index)[0].key,
                  target: this.dataE.nodes.filter(itemN => itemN.name == el[3] && itemN.query == index)[0].key,
                  attributes: {
                    type: `arrow`,
                    label: `${el[2]}`,
                    size: 5,
                    color: this.color[index],
                    count: 3
                  }
                })
              })
              b++
            })          
          }  
        },
        true,0
      );
    },
    addNodes(ind,min,max) {
      this.dataE.nodes.push({
        key: uuid(),
        name: el[ind],
        query: index,
        el: el,
        attributes: {
          x: this.randomInteger(min,max),
          y: Math.random(),
          size: 15,
          // label: `${item[1]} ` + `${item[2]}`,
          label: `${el[1]}`,
          color: '#306996'
        }
      })
      k++  
    },
  }
}
</script>

<style>
  #diagram {
    width: 100%;
    height: 100%;
  }
  #sigma-container {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
  .btn-container {
    display: flex;
    align-items: center;
  }
  .nav {
    display: flex;
    width: 50%;
  }
  .selContainer {
    width: 49%;
  }
  input {
    margin-right: 5px;
  }
  label {
    margin-right: 10px;
  }
</style>